import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Popover,
  Collapse,
  Button,
  Checkbox,
  Image,
  Tooltip,
  Radio,
  Space,
  Pagination,
  Select,
  Rate,
} from "antd";
import moment from "moment";
import StackGrid from "react-stack-grid";
import { useDispatch, useSelector } from "react-redux";
import { scroller, Element } from "react-scroll";
import accoArrow from "../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import fx from "../../assets/WidgetMaker/FX.svg";
import ParentPost from "../../assets/Parent_Post.svg";
import sortingIcon from "../../assets/sorting-icon.svg";
import sortingIconWhite from "../../assets/WhiteIcons/sortingWhite-icon.svg";
import Profile from "../../assets/Profile_Pic.svg";
import twitterIcon from "../../assets/SocialMediaPlatforms/twitter.svg";
import facebookIcon from "../../assets/SocialMediaPlatforms/facebook.svg";
import linkedinIcon from "../../assets/SocialMediaPlatforms/linkedin.svg";
import YoutubeIcon from "../../assets/SocialMediaPlatforms/Youtube.svg";
import instagramIcon from "../../assets/SocialMediaPlatforms/instagram.svg";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import placeHolderImg from "../../assets/placeholder_img.png";
import upvote from "../../assets/upvote.svg";
import shareQ from "../../assets/share_q.svg";
import shareQwhite from "../../assets/share_q_white.svg";
import BoostedPostIcon from "../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../assets/ads_post_icon.svg";
import androidImage from "../../assets/android_icon_image.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import userFollowers from "../../assets/FollowersBlue.svg";
import ClockIcon from "../../assets/Clock.svg";
import verified from "../../assets/verified.svg";
import FB_Like from "../../assets/FB_Like.svg";
import Youtube_Share from "../../assets/Youtube_Share.svg";
import Video_view from "../../assets/Video_view.svg";
import fb_share from "../../assets/fb_share.svg";
import instaShare from "../../assets/insta_share.svg";
import instaShareWhite from "../../assets/insta_share_white.svg";
import BackArrow from "../../assets/BackArrow.svg";
import BackArrowWhite from "../../assets/WhiteIcons/BackArrow_White.svg";
import reTweet from "../../assets/deepDive/reTweet.svg";
import like from "../../assets/deepDive/Like.svg";
import comment from "../../assets/deepDive/comment.svg";
import likewhite from "../../assets/deepDive/Like_white.svg";
import commentwhite from "../../assets/deepDive/comment_white.svg";
import reTweetwhite from "../../assets/deepDive/reTweet_white.svg";
import Video_view_white from "../../assets/Video_view_white.svg";
import Youtube_Share_white from "../../assets/Youtube_Share_white.svg";
import fb_share_white from "../../assets/fb_share_white.svg";
import upvotewhite from "../../assets/upvote_white.svg";
import FB_like_white from "../../assets/deepDive/FB_like_white.svg";
import somethingWentWrong from "../../assets/No_Data_Found.svg";
import featherPhone from "../../assets/feather-phone.svg";
import featherCopy from "../../assets/feather-copy.svg";
import simpleEmail from "../../assets/simple-email.svg";
import GraphList from "./GraphList";
import EngagedCard from "./EngagedCard";
import {
  setWidgetMakerPostCardTrends,
  setWidgetMakerPostCardShareTrends,
  setDashboardTrendsFlag,
} from "../../redux/actions/WidgetMaker/WidgetAPI";
import { setY_attribute } from "../../redux/actions/WidgetMaker/GraphConfig";
import ErrorBoundary from "../../ErrorBoundary";
import useScrollStopListener from "../layout2/dashboard/useScrollStopListener";
import {
  kFormatter,
  getTextWithWrapHtml,
  getClass,
} from "../../redux/constants";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import CarouselWidgetMaker from "./Carousel";
import QuotedPost from "./QuotedPost";
import PostAttachment from "./PostAttachment";
import postClickWhite from "../../assets/white_post_click_icon.svg";
import postClickBlack from "../../assets/black_post_click_icon.svg";
import NoGraphData from "../workspace/DisplayChart/NoGraphData";
import MarkInfluencerYellowIcon from "../../assets/CommandCenter/yellow_mark_Influencer_icon.svg";
import saved from "../../assets/deepDive/Saved.svg";
import white_Saved from "../../assets/deepDive/white_Saved.svg";
import moneyBagIcon from "../../assets/money-bag-icon.svg";
import moneyBagIconWhite from "../../assets/money-bag-icon-white.svg";
import PostLabels from "./PostLabels";
import InfoIcon from "../../assets/Info_Icon.svg";
import InfoIconYellow from "../../assets/Info_Icon_Yellow.svg";
import {
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
  sentimentClass,
} from "../../redux/constants/enums";
import { getDynamicIconColor } from "../../redux/constants/DynamicIconColor";
import { getDynamicChannelIcon } from "../../redux/constants/ChannelIcons";
import parse from "html-react-parser";
import { MentionIdComponent } from "./MentionIdComponent";

const { Panel } = Collapse;
const { Option } = Select;
const TrandsView = ({
  cardData,
  setTrandView,
  handleTrends,
  trendValue,
  mentionTrends,
  PdfDownloadStatus,
  PptGeneratingStatus,
  deepDive,
  setAutoPlay,
  onClickCancelTrends,
  section_index,
  widget_index,
  highlightWord,
  isDeepDiveDashboardView = false,
}) => {
  const CheckboxGroup = Checkbox.Group;
  const dispatch = useDispatch();
  const grid = useRef(null);
  const engagedRef = useRef(null);
  const widgetmakerPostCardTrands = useSelector(
    (state) => state.WidgetAPI.widgetmakerPostCardTrands
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [windowSize, setwindowSize] = useState(window.innerWidth);
  const [isCopyEmail, setIsCopyEmail] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [sectionActive, setSectionActive] = useState("reactions");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortBy, setSortBy] = useState(
    cardData?.PlatformID === 36 ? "createdDate" : "followers"
  );
  const [durationSelect, setDurationSelect] = useState("eight_hours");
  let plainOptions =
    cardData?.PlatformID === 1
      ? ["Positive", "Negative", "Neutral", "Retweet", "Replies"]
      : cardData?.PlatformID !== 36
      ? [
          "Positive",
          "Negative",
          "Neutral",
          "Shares",
          "Comments",
          "Verified Users",
          "Replies With Media",
        ]
      : ["Positive", "Negative", "Neutral"];
  const defaultCheckedList = plainOptions;

  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(true);
  const [engagedHeight, setEngagedHeight] = useState(300);
  const [readMore, setReadMore] = useState(false);
  const [chartFinalData, setchartFinalData] = useState(null);
  const [isImageLoadFailed, setIsImageLoadFailed] = useState(false);
  const [accordion, setAccordion] = useState([
    { id: 1, value: true },
    { id: 2, value: false },
    { id: 3, value: false },
  ]);
  const width = windowSize;
  let currentPage = widgetGraphConfig?.trends
    ? Math.round(widgetGraphConfig?.trends?.offset / 12)
    : 0;

  let totalPageLength = chartFinalData?.[5]?.data?.noOfPages * 12;

  useEffect(() => {
    const timer = setTimeout(() => {
      isCopyEmail && setIsCopyEmail(false);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [isCopyEmail]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (engagedRef) {
        let engagedHeightNew =
          engagedRef && engagedRef?.current?.clientHeight + 75; // adding 75 for subtract header and padding
        setEngagedHeight(engagedHeightNew);
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [
    engagedRef,
    engagedRef?.current?.clientHeight,
    widgetmakerPostCardTrands,
  ]);

  useEffect(() => {
    let data = widgetmakerPostCardTrands?.map((el, i) => {
      if (el?.card_type === "User Post" && cardData?.PlatformID === 2) {
        if (
          el?.widget_id === 1 ||
          el?.widget_id === 2 ||
          el?.widget_id === 3 ||
          el?.widget_id === 4
        ) {
          return {
            chart_type: el?.chart_type,
            data: el?.data,
            widget_id: el?.widget_id,
            widget_loader: el?.widget_loader,
          };
        } else return null;
      }
      // else if (el?.card_type === "User Post" && cardData?.PlatformID === 3) {
      //   if (
      //     el?.widget_id === 1 ||
      //     el?.widget_id === 2 ||
      //     el?.widget_id === 3 ||
      //     el?.widget_id === 4
      //   ) {
      //     return {
      //       chart_type: el?.chart_type,
      //       data: el?.data,
      //       widget_id: el?.widget_id,
      //       widget_loader: el?.widget_loader,
      //     };
      //   } else return null;
      // } else if (el?.card_type === "Brand Post" && cardData?.PlatformID === 3) {
      //   if (
      //     el?.widget_id === 1 ||
      //     el?.widget_id === 2 ||
      //     el?.widget_id === 3 ||
      //     el?.widget_id === 4
      //   ) {
      //     return {
      //       chart_type: el?.chart_type,
      //       data: el?.data,
      //       widget_id: el?.widget_id,
      //       widget_loader: el?.widget_loader,
      //     };
      //   } else return null;
      // }
      else if (
        el?.card_type === "Brand Post" &&
        (cardData?.PlatformID === 2 ||
          cardData?.PlatformID === 4 ||
          cardData?.PlatformID === 5)
      ) {
        if (
          el?.widget_id === 1 ||
          el?.widget_id === 2 ||
          el?.widget_id === 3 ||
          el?.widget_id === 4 ||
          el?.widget_id === 5
        ) {
          return {
            chart_type: el?.chart_type,
            data: el?.data,
            widget_id: el?.widget_id,
            widget_loader: el?.widget_loader,
          };
        } else return null;
      } else {
        return {
          chart_type: el?.chart_type,
          data: el?.data,
          widget_id: el?.widget_id,
          widget_loader: el?.widget_loader,
        };
      }
    });
    setchartFinalData(data);
  }, [widgetmakerPostCardTrands]);

  // Temporary commented this code start

  const isInViewport = function (elem) {
    const bounding = elem.getBoundingClientRect();

    return (
      bounding.top + 1000 >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  const getBlocks = function (blocks) {
    blocks.forEach((block) => {
      if (isInViewport(block)) {
        if (block.id === "element_user_reactions")
          setSectionActive("reactions");
        else if (block.id === "engaged_user_profiles")
          setSectionActive("profiles");
        else if (block.id === "element_retweet_map") setSectionActive("maps");
        // else if (block.id == "1") {
        //   let brand_post =
        //     trendValue?.card_type === "Brand Post" ? true : false;
        //   !widgetmakerPostCardTrands[
        //     brand_post ? parseInt(block.id) - 1 : parseInt(block.id)
        //   ]?.data &&
        //     !loaderTrends &&
        //     handleTrends(trendValue, block.id, widgetmakerPostCardTrands);
        // } else if (block.id == "2") {
        //   let brand_post =
        //     trendValue?.card_type === "Brand Post" ? true : false;
        //   !widgetmakerPostCardTrands[
        //     brand_post ? parseInt(block.id) - 1 : parseInt(block.id)
        //   ]?.data &&
        //     !loaderTrends &&
        //     handleTrends(trendValue, block.id, widgetmakerPostCardTrands);
        // } else if (block.id == "3") {
        //   let brand_post =
        //     trendValue?.card_type === "Brand Post" ? true : false;
        //   !widgetmakerPostCardTrands[
        //     brand_post ? parseInt(block.id) - 1 : parseInt(block.id)
        //   ]?.data &&
        //     !loaderTrends &&
        //     handleTrends(trendValue, block.id, widgetmakerPostCardTrands);
        // } else if (block.id == "4") {
        //   let brand_post =
        //     trendValue?.card_type === "Brand Post" ? true : false;
        //   !widgetmakerPostCardTrands[
        //     brand_post ? parseInt(block.id) - 1 : parseInt(block.id)
        //   ]?.data &&
        //     !loaderTrends &&
        //     handleTrends(trendValue, block.id, widgetmakerPostCardTrands);
        // }
      }
    });
  };
  useScrollStopListener(
    document.getElementById("TreandsChartsContainer")
      ? document.getElementById("TreandsChartsContainer")
      : window,

    () => {
      const blocks = document.querySelectorAll(".trends");
      const widget_block = document.querySelectorAll(".widget_trends");

      getBlocks(blocks);
      getBlocks(widget_block);
    },
    [100]
  );
  const pantipChannel = useMemo(() => {
    return cardData && cardData?.PlatformID === 43;
  }, [cardData]);
  // Temporary commented this code end

  const userProfileData =
    widgetmakerPostCardTrands && widgetmakerPostCardTrands[0]?.data?.data[0];

  const updateSize = () => {
    setwindowSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const handelScroll = (event) => {
    setIsOpen(false);
  };
  useEffect(() => {
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", handelScroll);
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", handelScroll);
    };
  }, []);

  const resizeGrid = () => {
    let timer1,
      timer2 = null;
    if (grid?.current) {
      timer1 = setTimeout(() => {
        grid?.current?.updateLayout();
      }, 100);
    }
    if (chartFinalData?.[5]?.data?.data?.length > 0) {
      timer2 = setTimeout(() => {
        grid && grid?.current?.updateLayout();
      }, 1500);
    }
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  };
  useEffect(resizeGrid, [width]);
  const hendleClick = (e) => {
    resizeGrid();
  };
  const chart__styles = {
    width: "100%",
    height: "350px",
  };

  const ScrollToElement = (element, containerId) => {
    scroller.scrollTo(element, {
      duration: 500,
      delay: 0,
      smooth: true,
      offset: -15,
      containerId: "TreandsChartsContainer",
    });
  };

  const onhandleTrandsCheckChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < plainOptions.length);
    setCheckAll(list.length === plainOptions.length);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? plainOptions : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };
  const menuEngaged = (
    <div className="text_regular pt-15" style={{ minWidth: "20rem" }}>
      <div className="ml-15 mr-15 mb-1">
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
        >
          All
        </Checkbox>
      </div>
      <div className="checkboxGroup ml-15 mr-15 mb-2">
        <CheckboxGroup
          options={plainOptions}
          value={checkedList}
          onChange={onhandleTrandsCheckChange}
        />
      </div>
      <div className="text-right border-top border-color pt-15 pb-15 pr-15">
        <Button
          className="mr-15 btn_Clear"
          onClick={() => handleFilterCancel()}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={() => handleFilterApply()}
          className="ant-btn-primary_blue"
          disabled={checkAll || checkedList.length > 0 ? false : true}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  const handleFilterApply = () => {
    setIsOpen(false);
    let tab_array = widgetmakerPostCardTrands && [...widgetmakerPostCardTrands];
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let postCardObject;
    widgetmakerPostCardTrands?.map((d) => {
      if (d?.widget_id === 5) {
        postCardObject = d;
      }
    });

    let updatedOrderBy = {
      attribute: sortBy,
      sort_order: sortOrder,
      offset: 0,
    };
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        trends: updatedOrderBy,
      })
    );
    let obj = {
      ...postCardObject,
      utcOffset: utcOffset,
      offset: 0,
      isAll: checkAll ? 1 : 0,
      isVerified:
        checkedList.findIndex((el) => el === "Verified Users") >= 0 && !checkAll
          ? 1
          : 0,
      sentimentType: {
        ispositive:
          checkedList.findIndex((el) => el === "Positive") >= 0 && !checkAll
            ? 1
            : 0,
        isnegative:
          checkedList.findIndex((el) => el === "Negative") >= 0 && !checkAll
            ? 1
            : 0,
        isneutral:
          checkedList.findIndex((el) => el === "Neutral") >= 0 && !checkAll
            ? 1
            : 0,
      },
      isreply:
        (checkedList.findIndex((el) => el === "Replies") >= 0 ||
          checkedList.findIndex((el) => el === "Comments") >= 0) &&
        !checkAll
          ? 1
          : 0,
      isretweet:
        (checkedList.findIndex((el) => el === "Retweet") >= 0 ||
          checkedList.findIndex((el) => el === "Shares") >= 0) &&
        !checkAll
          ? 1
          : 0,
      isreplywmedia:
        checkedList.findIndex((el) => el === "Replies With Media") >= 0 &&
        !checkAll
          ? 1
          : 0,
      trends_duration: null,
      attribute: sortBy,
      sort_order: sortOrder,
      uniqueid: cardData?.uniqueid,
    };
    if (window.location.pathname === "/share") {
      shareCategory &&
        dispatch(
          setWidgetMakerPostCardShareTrends(shareCategory, obj, tab_array)
        );
    } else {
      authParams &&
        dispatch(setWidgetMakerPostCardTrends(authParams, obj, tab_array));
    }
  };
  const handleFilterCancel = () => {
    setIsOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setIsOpen(newOpen);
  };

  const emailCopy = (email) => {
    navigator.clipboard.writeText(email).then(
      () => {
        setIsCopyEmail(true);
      },
      () => {
        setIsCopyEmail(false);
      }
    );
  };

  const handleChangeSorting = (e, type) => {
    let tab_array = widgetmakerPostCardTrands && [...widgetmakerPostCardTrands];
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let postCardObject;
    widgetmakerPostCardTrands?.map((d) => {
      if (d?.widget_id === 5) {
        postCardObject = d;
      }
    });

    let updatedOrderBy = {
      attribute: sortBy,
      sort_order: sortOrder,
      offset: 0,
    };
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        trends: updatedOrderBy,
      })
    );

    let obj = {
      ...postCardObject,
      utcOffset: utcOffset,
      offset: 0,
      isAll: checkAll ? 1 : 0,
      isVerified:
        checkedList.findIndex((el) => el === "Verified Users") >= 0 && !checkAll
          ? 1
          : 0,
      sentimentType: {
        ispositive:
          checkedList.findIndex((el) => el === "Positive") >= 0 && !checkAll
            ? 1
            : 0,
        isnegative:
          checkedList.findIndex((el) => el === "Negative") >= 0 && !checkAll
            ? 1
            : 0,
        isneutral:
          checkedList.findIndex((el) => el === "Neutral") >= 0 && !checkAll
            ? 1
            : 0,
      },
      isreply:
        (checkedList.findIndex((el) => el === "Replies") >= 0 ||
          checkedList.findIndex((el) => el === "Comments") >= 0) &&
        !checkAll
          ? 1
          : 0,
      isretweet:
        (checkedList.findIndex((el) => el === "Retweet") >= 0 ||
          checkedList.findIndex((el) => el === "Shears") >= 0) &&
        !checkAll
          ? 1
          : 0,
      isreplywmedia:
        checkedList.findIndex((el) => el === "Replies With Media") >= 0 &&
        !checkAll
          ? 1
          : 0,
      trends_duration: null,
      attribute: type === "sortBy" ? e : sortBy,
      sort_order: type === "sortOrder" ? e : sortOrder,
      uniqueid: cardData?.uniqueid,
    };
    if (window.location.pathname === "/share") {
      shareCategory &&
        dispatch(
          setWidgetMakerPostCardShareTrends(shareCategory, obj, tab_array)
        );
    } else {
      authParams &&
        dispatch(setWidgetMakerPostCardTrends(authParams, obj, tab_array));
    }
  };
  const sortingMenu = (
    <div className="text_regular">
      <div className="text_regular font-size14 p-0 sortBy">
        <div className="w-100">
          <Radio.Group
            onChange={(e) => {
              setSortBy(e.target.value);
              handleChangeSorting(e.target.value, "sortBy");
            }}
            defaultValue={sortBy}
            value={sortBy}
          >
            <Space direction="vertical">
              <div className="text_regular font-weight500 font-size14 pl-15 pt-2">
                Sort By
              </div>
              {cardData?.PlatformID !== 36 && (
                <>
                  <Radio
                    className="text_regular font-size14 pt-2 pb-0 pl-15"
                    value="engagement"
                  >
                    Interaction
                  </Radio>
                  <Radio
                    className="text_regular font-size14 pt-2 pb-0 pl-15"
                    value="followers"
                  >
                    Followers
                  </Radio>
                </>
              )}

              <Radio
                className="text_regular font-size14 pt-2 pb-2 pl-15"
                value="createdDate"
              >
                Reply Time
              </Radio>
            </Space>
          </Radio.Group>
        </div>
        <Radio.Group
          onChange={(e) => {
            setSortOrder(e.target.value);
            handleChangeSorting(e.target.value, "sortOrder");
          }}
          defaultValue={sortOrder}
          value={sortOrder}
        >
          <Space direction="vertical" className="w-100">
            <div className="text_regular font-weight500 font-size14 pt-2 pl-15 border-top border-color">
              Sort Order
            </div>
            <Radio
              className="text_regular font-size14 pt-2 pb-0 pl-15"
              value="asc"
            >
              Ascending
            </Radio>
            <Radio
              className="text_regular font-size14 pt-2 pb-2 pl-15"
              value="desc"
            >
              Descending
            </Radio>
          </Space>
        </Radio.Group>
      </div>
    </div>
  );

  const handleChangePagination = (page, type) => {
    let newPage = page - 1;
    let pageNo = newPage * 12;

    let tab_array = widgetmakerPostCardTrands && [...widgetmakerPostCardTrands];
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let updatedOrderBy = {
      attribute: sortBy,
      sort_order: sortOrder,
      offset: pageNo,
    };
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        trends: updatedOrderBy,
      })
    );

    let postCardObject;
    widgetmakerPostCardTrands?.map((d) => {
      if (d?.widget_id === 5) {
        postCardObject = d;
      }
    });

    let obj = {
      ...postCardObject,
      utcOffset: utcOffset,
      offset: pageNo,
      isAll: checkAll ? 1 : 0,
      isVerified:
        checkedList.findIndex((el) => el === "Verified Users") >= 0 && !checkAll
          ? 1
          : 0,
      sentimentType: {
        ispositive:
          checkedList.findIndex((el) => el === "Positive") >= 0 && !checkAll
            ? 1
            : 0,
        isnegative:
          checkedList.findIndex((el) => el === "Negative") >= 0 && !checkAll
            ? 1
            : 0,
        isneutral:
          checkedList.findIndex((el) => el === "Neutral") >= 0 && !checkAll
            ? 1
            : 0,
      },
      isreply:
        (checkedList.findIndex((el) => el === "Replies") >= 0 ||
          checkedList.findIndex((el) => el === "Comments") >= 0) &&
        !checkAll
          ? 1
          : 0,
      isretweet:
        (checkedList.findIndex((el) => el === "Retweet") >= 0 ||
          checkedList.findIndex((el) => el === "Shears") >= 0) &&
        !checkAll
          ? 1
          : 0,
      isreplywmedia:
        checkedList.findIndex((el) => el === "Replies With Media") >= 0 &&
        !checkAll
          ? 1
          : 0,
      trends_duration: null,
      attribute: sortBy,
      sort_order: sortOrder,
      uniqueid: cardData?.uniqueid,
    };
    if (window.location.pathname === "/share") {
      shareCategory &&
        dispatch(
          setWidgetMakerPostCardShareTrends(shareCategory, obj, tab_array)
        );
    } else {
      authParams &&
        dispatch(setWidgetMakerPostCardTrends(authParams, obj, tab_array));
      hendleClick();
    }
  };

  const handleDurationChange = (e) => {
    setDurationSelect(e);
    let tab_array = widgetmakerPostCardTrands && [...widgetmakerPostCardTrands];
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let postCardObject;
    widgetmakerPostCardTrands?.map((d) => {
      if (d?.widget_id === 2) {
        postCardObject = d;
      }
    });

    let obj = {
      ...postCardObject,
      utcOffset: utcOffset,
      offset: 0,
      isVerified:
        checkedList.findIndex((el) => el === "Verified Users") >= 0 ? 1 : 0,
      sentimentType: {
        ispositive:
          checkedList.findIndex((el) => el === "Positive") >= 0 ? 1 : 0,
        isnegative:
          checkedList.findIndex((el) => el === "Negative") >= 0 ? 1 : 0,
        isneutral: checkedList.findIndex((el) => el === "Neutral") >= 0 ? 1 : 0,
      },
      isreply:
        checkedList.findIndex((el) => el === "Replies") >= 0 ||
        checkedList.findIndex((el) => el === "Comments") >= 0
          ? 1
          : 0,
      isretweet:
        checkedList.findIndex((el) => el === "Retweet") >= 0 ||
        checkedList.findIndex((el) => el === "Shears") >= 0
          ? 1
          : 0,
      isreplywmedia:
        checkedList.findIndex((el) => el === "Replies With Media") >= 0 ? 1 : 0,
      trends_duration: e,
      attribute: sortBy,
      sort_order: sortOrder,
      uniqueid: cardData?.uniqueid,
    };
    if (window.location.pathname === "/share") {
      shareCategory &&
        dispatch(
          setWidgetMakerPostCardShareTrends(shareCategory, obj, tab_array)
        );
    } else {
      authParams &&
        dispatch(setWidgetMakerPostCardTrends(authParams, obj, tab_array));
    }
  };

  const handleBack = () => {
    // To Start Carousel in Brand Post Screen
    if (authParams?.screen_id === "000-000-562" && !isDeepDiveDashboardView) {
      if (typeof setAutoPlay === "function" && setAutoPlay) {
        setAutoPlay(true);
      }
    }
    if (authParams?.screen_id === "000-000-561" && !isDeepDiveDashboardView) {
      if (typeof onClickCancelTrends === "function" && onClickCancelTrends) {
        onClickCancelTrends();
      }
    }
    if (window?.parent && mentionTrends) {
      window?.parent?.postMessage(
        {
          eventCode: 2,
          message: "Close Trend From AWA domain",
        },
        "*" //"http://localhost:4200"
      );
      // Use target origin instead of *
    }
    setTrandView({
      modalShow: false,
      data: null,
    });
    dispatch(setDashboardTrendsFlag(false));
    dispatch(
      setY_attribute({
        ...widgetGraphConfig,
        trends: null,
      })
    );
    dispatch(setWidgetMakerPostCardTrends(null));
  };
  const handelProfile = (event) => {
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let obj = {
      card_type: cardData?.card_type,
      content_id: cardData?.PostContentID,
      brand_id: cardData?.PostBrandID,
      author_id: cardData?.AuthorAuthorID,
      post_id: cardData?.PostPostID,
      retweet_id: cardData?.RetweetedStatusID,
      reply_id: cardData?.InReplytostatusID,
      channel_group_id: cardData?.PlatformID || cardData.ChannelGroupId,
      tag_id: cardData?.TagID ? cardData?.TagID : cardData?.tagid,
      utcOffset: utcOffset,
      offset: 0,
      isVerified: 0,
      sentimentType: {
        ispositive: 0,
        isnegative: 0,
        isneutral: 0,
      },
      trends_duration: null,
      isreply: 0,
      isretweet: 0,
      isreplywmedia: 0,
      attribute: "followers",
      sort_order: "desc",
      chart_type: "engaged_profiles_data",
      widget_id: 5,
      widget_loader: false,
      uniqueid: cardData?.uniqueid,
    };
    const id = widgetmakerPostCardTrands?.filter(
      (el, i) => el?.widget_id === 5
    );
    if (id?.length === 0 && window.location.pathname !== "/share") {
      authParams &&
        dispatch(
          setWidgetMakerPostCardTrends(authParams, obj, [
            ...widgetmakerPostCardTrands,
            obj,
          ])
        );
    } else if (id?.length === 0 && window.location.pathname === "/share") {
      shareCategory &&
        dispatch(
          setWidgetMakerPostCardShareTrends(shareCategory, obj, [
            ...widgetmakerPostCardTrands,
            obj,
          ])
        );
    }
    ScrollToElement(event);
  };
  const handelMaps = (event) => {
    let tab_array = [
      { widget_id: 6, chart_type: "retweet_map", widget_loader: true },
      { widget_id: 7, chart_type: "reply_map", widget_loader: true },
    ];
    const d = new Date();
    let utcOffset = d.getTimezoneOffset();
    tab_array = tab_array?.map((el, i) => {
      let obj = {
        ...el,
        card_type: cardData?.card_type,
        content_id: cardData?.PostContentID,
        brand_id: cardData?.PostBrandID,
        author_id: cardData?.AuthorAuthorID,
        post_id: cardData?.PostPostID,
        retweet_id: cardData?.RetweetedStatusID,
        reply_id: cardData?.InReplytostatusID,
        channel_group_id: cardData?.PlatformID || cardData.ChannelGroupId,
        tag_id: cardData?.TagID ? cardData?.TagID : cardData?.tagid,
        utcOffset: utcOffset,
        offset: 0,
        isVerified: 0,
        sentimentType: {
          ispositive: 0,
          isnegative: 0,
          isneutral: 0,
        },
        trends_duration: el?.widget_id ? el?.widget_id : null,
        isreply: 0,
        isretweet: 0,
        isreplywmedia: 0,
        attribute: "followers",
        sort_order: "desc",
        uniqueid: cardData?.uniqueid,
      };
      return obj;
    });
    const id = widgetmakerPostCardTrands?.filter(
      (el) => el?.widget_id === 6 || el?.widget_id === 7
    );
    if (id?.length === 0 && window.location.pathname !== "/share") {
      tab_array?.forEach((el) => {
        authParams &&
          dispatch(
            setWidgetMakerPostCardTrends(authParams, el, [
              ...widgetmakerPostCardTrands,
              ...tab_array,
            ])
          );
      });
    } else if (id?.length === 0 && window.location.pathname === "/share") {
      tab_array?.forEach((el) => {
        shareCategory &&
          dispatch(
            setWidgetMakerPostCardShareTrends(shareCategory, el, [
              ...widgetmakerPostCardTrands,
              ...tab_array,
            ])
          );
      });
    }
    ScrollToElement("element_retweet_map");
  };
  const accoArrowDw = (e, link) => {
    setSectionActive(e);
    if (e === "maps") {
      const getValue = accordion?.map((el, i) => {
        if (el?.id === 3) {
          return {
            id: 3,
            value: link === "top" ? true : !el?.value,
          };
        }
        return el;
      });
      setAccordion([...getValue]);
      handelMaps("maps");
    } else if (e === "reactions") {
      const getValue = accordion?.map((el, i) => {
        if (el?.id === 1) {
          return {
            id: 1,
            value: link === "top" ? true : !el?.value,
          };
        }
        return el;
      });
      setAccordion([...getValue]);
      ScrollToElement("element_user_reactions");
    } else if (e === "profiles") {
      const getValue = accordion?.map((el, i) => {
        if (el?.id === 2) {
          return {
            id: 2,
            value: link === "top" ? true : !el?.value,
          };
        }
        return el;
      });
      setAccordion([...getValue]);
      handelProfile("engaged_user_profiles");
      resizeGrid();
    }
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e) => {
    if (e?.type === "error") {
      setIsImageLoadFailed(true);
    } else {
      setIsImageLoadFailed(false);
    }
    return (e.target.src = defaultImg);
  };
  return (
    <div className="row m-0">
      <div className="col-12 col-md-4 pl-0 pr-0">
        <div
          className={`cursor-pointer d-flex align-items-center text_heading font-weight500 fontSize-16 pt-2 pb-2 border-bottom border-right border-color pl-15`}
          style={{ height: "5rem" }}
          onClick={handleBack}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            className="RecentlySaved__header__left__arrow mr-1 ml-0"
            style={{
              fill: "var(--locobuzz-primary-text-color, #3b5175)",
              cursor: "pointer",
            }}
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
              fill="var(--locobuzz-primary-text-color)"
            />
          </svg>
          {/* <img
            src={authParams?.theme_type === "1" ? BackArrowWhite : BackArrow}
            style={{ maxWidth: "2rem" }}
            className={`mr-1`}
            alt="Trends Back Arrow Img"
          /> */}
          <span class="text_regular font-weight600 deepdive__span">Trends</span>
        </div>
        <div
          className="custom_scroll1 border-right border-color"
          style={{ height: "calc(100vh - 5.6rem)", overflow: "auto" }}
        >
          <div className="pl-15 pr-15">
            <div className="text_heading font-weight500 pt-15 pb-15 text-transform__capitalize">
              {cardData?.card_type?.split("_").join(" ")}
            </div>
            <div
              className={`card cardList border-color postcard-class-for-mention ${
                sentimentClass[cardData?.SentimentType] || "default-text-color"
              }`}
            >
              <MentionIdComponent
                color={cardData?.SentimentType}
                id={cardData?.mention_id}
                trendView={true}
              />
              <div
                className={`cardList-head card-head text_heading d-flex justify-content-between p-15 mt-0 align-items-top ${
                  cardData?.SentimentType ? "pl-0" : ""
                } ${cardData?.IsDeletedFromSocial ? "pr-0" : ""} ${
                  postCardUserbrandPrivateMessagesId?.includes(
                    cardData?.channel_type
                  )
                    ? getClass(authParams, "message")
                    : cardData?.PlatformID == 1 &&
                      cardData?.ParentSocialID !== "NA" &&
                      cardData?.ParentSocialID != 0 &&
                      cardData?.ParentSocialID !== ""
                    ? getClass(authParams, "comment")
                    : postCardUserBrandCommentId?.includes(
                        cardData?.channel_type
                      ) && cardData?.PlatformID != 1
                    ? getClass(authParams, "comment")
                    : getClass(authParams, "post")
                } ${cardData?.IsDeletedFromSocial ? "pr-0" : ""}`}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ width: "53%" }}
                >
                  {cardData?.SentimentType ? (
                    <div
                      style={{
                        borderLeft: `0.4rem solid ${
                          cardData?.SentimentType === "Positive"
                            ? "#5ED142"
                            : cardData?.SentimentType === "Negative"
                            ? "#FF5D48"
                            : cardData?.SentimentType === "Neutral"
                            ? "#F0C52F"
                            : "black"
                        }`,
                        height: "3.6rem",
                        marginRight: "1rem",
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                  {/* {cardData?.brand_logo && (
                    <Image
                      src={
                        cardData?.brand_logo
                          ? cardData?.brand_logo
                          : Default_Brand
                      }
                      fallback={
                        cardData?.brand_logo
                          ? cardData?.brand_logo
                          : Default_Brand
                      }
                      preview={false}
                      alt="Brand logo"
                      className="profileImg ml-1 cursor-pointer"
                      style={{
                        width: "3.5rem",
                        height: "3.5rem",
                        marginTop: "-0.5rem",
                        marginRight: "0.5rem",
                      }}
                    />
                  )} */}

                  {(authParams?.screen_id === "000-000-554" ||
                    authParams?.screen_id === "000-000-564") &&
                  !isDeepDiveDashboardView ? (
                    ""
                  ) : cardData?.brand_logo &&
                    cardData?.brand_logo !== "NA" &&
                    cardData?.BrandFriendlyName &&
                    cardData?.BrandFriendlyName !== "NA" &&
                    cardData?.BrandFriendlyName !== "" ? (
                    <Popover
                      placement="leftBottom"
                      title={null}
                      content={
                        <div
                          style={{
                            maxWidth: "25rem",
                            maxHeight: "20rem",
                            overflow: "auto",
                          }}
                          className="text_regular fontSize-12 p-10"
                        >
                          {cardData?.BrandFriendlyName}
                        </div>
                      }
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                    >
                      <Image
                        src={
                          cardData?.brand_logo
                            ? cardData?.brand_logo
                            : Default_Brand
                        }
                        fallback={
                          cardData?.brand_logo
                            ? cardData?.brand_logo
                            : Default_Brand
                        }
                        preview={false}
                        alt="Brand logo"
                        onError={getDefautBrandImg}
                        className="profileImg mr-1 cursor-pointer"
                        style={{
                          width: "3.5rem",
                          height: "3.5rem",
                          //marginTop: "-0.5rem",
                          marginRight: "0.5rem",
                        }}
                      />
                    </Popover>
                  ) : (
                    <Popover
                      placement="leftBottom"
                      title={null}
                      content={
                        <div
                          style={{
                            maxWidth: "25rem",
                            maxHeight: "20rem",
                            overflow: "auto",
                          }}
                          className="text_regular fontSize-12 p-10"
                        >
                          {cardData?.BrandFriendlyName}
                        </div>
                      }
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                    >
                      <Image
                        src={
                          cardData?.brand_logo
                            ? cardData?.brand_logo
                            : Default_Brand
                        }
                        fallback={
                          cardData?.brand_logo
                            ? cardData?.brand_logo
                            : Default_Brand
                        }
                        preview={false}
                        alt="Brand logo"
                        onError={getDefautBrandImg}
                        className="profileImg mr-1 cursor-pointer"
                        style={{
                          width: "3.5rem",
                          height: "3.5rem",
                          //marginTop: "-0.5rem",
                          marginRight: "0.5rem",
                        }}
                      />
                    </Popover>
                  )}

                  {/* Profile Logo */}
                  <div
                    className="position-relative mr-15"
                    style={{ width: "3.5rem" }}
                  >
                    <Popover
                      placement="leftBottom"
                      title={null}
                      content={
                        <div className="p-15">
                          {cardData?.AuthorBio &&
                          cardData?.AuthorBio !== "NA" &&
                          cardData?.AuthorBio !== "" ? (
                            <div className="text_regular font-weight500">
                              Bio
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            style={{
                              maxWidth: "25rem",
                              maxHeight: "20rem",
                              overflow: "auto",
                            }}
                            className="text_regular fontSize-12 custom_scroll1"
                          >
                            {cardData?.AuthorBio &&
                            cardData?.AuthorBio !== "NA" &&
                            cardData?.AuthorBio !== "" ? (
                              <>{cardData?.AuthorBio}</>
                            ) : (
                              <div className="text-grayLight fontSize-14 d-flex justify-content-center align-items-center w-100">
                                Bio not found
                              </div>
                            )}
                          </div>
                        </div>
                      }
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                    >
                      <Image
                        src={
                          cardData?.picurl && cardData?.picurl !== ""
                            ? cardData?.picurl === 0 ||
                              cardData?.picurl === "" ||
                              !cardData?.picurl
                              ? Profile
                              : cardData?.picurl
                            : cardData?.ProfilePicture === 0 ||
                              cardData?.ProfilePicture === "" ||
                              !cardData?.ProfilePicture
                            ? Profile
                            : cardData?.ProfilePicture
                        }
                        fallback={Profile}
                        preview={false}
                        alt="Profile Images"
                        className="profileImg mr-0 cursor-pointer"
                        style={{
                          width: "3.5rem",
                          height: "3.5rem",
                        }}
                        // crossOrigin="anonymous"
                      />
                    </Popover>

                    <div
                      className="position-absolute"
                      style={{ right: "-0.8rem", top: "-0.4rem" }}
                    >
                      <Image
                        src={
                          cardData?.PlatformID === 0
                            ? Default_Brand
                            : SocialMedialogo?.[cardData?.PlatformID]
                            ? SocialMedialogo?.[cardData?.PlatformID]
                            : Default_Brand
                        }
                        alt="Channel"
                        preview={false}
                        fallback={Default_Brand}
                        style={{
                          width: "1.6rem",
                          maxHeight: "2rem",
                          verticalAlign: "top",
                        }}
                      />
                    </div>
                  </div>

                  {/* Author Name */}
                  {/* Changing max width logic here if sentimentType exits subtracting 1.5rem ,
                            85px + 0.4rem for Brand and Profile so Author Name box should not go outside  */}
                  <div
                    // style={{ width: "calc(100% - 6.3rem)" }}
                    style={{
                      width: `calc(100% - ${
                        (cardData?.SentimentType ? 15 : 0) +
                        (!["000-000-554", "000-000-564"]?.includes(
                          authParams?.screen_id
                        ) && !isDeepDiveDashboardView
                          ? 35
                          : 0) + // for brand
                        50 // for profile
                      }px - ${
                        !["000-000-554", "000-000-564"]?.includes(
                          authParams?.screen_id
                        ) && !isDeepDiveDashboardView
                          ? 0.4
                          : 0
                      }rem)`,
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <Tooltip
                        title={
                          cardData?.AuthorName
                            ? cardData?.AuthorName
                            : cardData?.Author
                        }
                      >
                        <div className="profileName text-ellipsis line-height-normal">
                          {cardData?.AuthorURL &&
                          cardData?.AuthorURL !== "NA" ? (
                            <a
                              className={
                                cardData?.AuthorURL &&
                                cardData?.AuthorURL !== "NA"
                                  ? ""
                                  : "pointer-events1 cursor-default"
                              }
                              href={
                                cardData?.AuthorURL &&
                                cardData?.AuthorURL !== "NA"
                                  ? cardData?.AuthorURL
                                  : ""
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {cardData?.Author
                                ? cardData?.Author
                                : cardData?.AuthorName}
                            </a>
                          ) : (
                            <>
                              {cardData?.Author
                                ? cardData?.Author
                                : cardData?.AuthorName}
                            </>
                          )}
                        </div>
                      </Tooltip>
                      {(authParams?.screen_id &&
                        !deepDive &&
                        !isDeepDiveDashboardView &&
                        cardData?.isVerified &&
                        cardData?.isVerified !== "NA" &&
                        cardData?.isVerified === "Verified") ||
                      (cardData?.AuthorIsVerified !== "NA" &&
                        cardData?.AuthorIsVerified &&
                        cardData?.AuthorIsVerified > 0) ? (
                        <img
                          src={verified}
                          alt="verified"
                          className="profileImg ml-1"
                          style={{ width: "1.6rem", height: "1.6rem" }}
                        />
                      ) : (
                        ""
                      )}
                      {cardData?.isPromoted === 1 ? (
                        <Tooltip title="Boosted post">
                          <img
                            alt="Boosted Post Icon"
                            src={BoostedPostIcon}
                            className="mr-0"
                            style={{
                              width: "2rem",
                              height: "2rem",
                            }}
                          />
                        </Tooltip>
                      ) : cardData?.isPromoted === 2 ||
                        cardData?.isPromoted === 5 ? (
                        <Tooltip
                          title={
                            cardData?.isPromoted === 5
                              ? "Dark Ad Post"
                              : "Ad Post"
                          }
                        >
                          <img
                            alt="Ad Post Icon"
                            src={AdsPostIcon}
                            className="mr-0"
                            style={{
                              width: "2rem",
                              height: "2rem",
                            }}
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                    {cardData?.AuthorScreenName &&
                    cardData?.PlatformID !== 2 &&
                    cardData?.PlatformID !== 5 ? (
                      <div
                        className="screenName text-grayLight text-ellipsis w-100"
                        //style={{ width: "90%" }}
                      >
                        <Tooltip title={cardData?.AuthorScreenName}>
                          {cardData?.AuthorURL &&
                          cardData?.AuthorURL !== "NA" ? (
                            <a
                              className={
                                cardData?.AuthorURL &&
                                cardData?.AuthorURL !== "NA"
                                  ? ""
                                  : "pointer-events1 cursor-default"
                              }
                              href={
                                cardData?.AuthorURL &&
                                cardData?.AuthorURL !== "NA"
                                  ? cardData?.AuthorURL
                                  : ""
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {cardData?.AuthorScreenName}
                            </a>
                          ) : (
                            <>{cardData?.AuthorScreenName}</>
                          )}
                        </Tooltip>
                      </div>
                    ) : cardData?.ScreenName &&
                      cardData?.PlatformID !== 2 &&
                      cardData?.PlatformID !== 5 ? (
                      <div
                        className="screenName text-grayLight text-ellipsis w-100"
                        //style={{ width: "90%" }}
                      >
                        <Tooltip title={cardData?.ScreenName}>
                          {cardData?.ScreenName}
                        </Tooltip>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <span
                  className="font-size12 align-items-center d-flex date-icons-header"
                  style={{ maxWidth: "40%" }}
                >
                  <Tooltip
                    title={
                      <div>
                        Created Date : <br />{" "}
                        {authParams?.screen_id &&
                        cardData?.CreatedDate &&
                        cardData?.CreatedDate_tooltip
                          ? cardData?.CreatedDate_tooltip
                          : cardData?.CreatedDate
                          ? cardData?.CreatedDate
                          : cardData?.PostCreatedDate}
                      </div>
                    }
                    className="no--wrap"
                    style={{ maxWidth: "47%" }}
                  >
                    {/* <img
                      src={ClockIcon}
                      className="cardList__footer-label"
                      alt="ClockIcon"
                    /> */}
                    <span className="cardList__footer-label">
                      {getDynamicIconColor("clock_icon")}
                    </span>
                    <span className="cardList__footer-count text-grayLight">
                      {authParams?.screen_id && cardData?.CreatedDate
                        ? cardData?.CreatedDate
                        : cardData?.CreatedDate
                        ? moment(cardData?.CreatedDate)?.format("DD MMM YYYY")
                        : moment(cardData?.PostCreatedDate)?.format(
                            "DD MMM YYYY"
                          )}
                    </span>
                  </Tooltip>
                  {cardData?.IsDeletedFromSocial ? (
                    <Tooltip
                      title={<div>Deleted From Social</div>}
                      placement="topRight"
                      className="no--wrap"
                    >
                      <span
                        className={`deletedFromSocialIcon ${"d-flex align-items-center"} `}
                      >
                        <i className="fas fa-trash-alt trash__icon"></i>
                      </span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </span>
              </div>
              <div className="card-body p-0">
                <div className="mb-15 pl-15 d-flex justify-content-between pr-15">
                  {cardData?.PlatformID === 1 ? (
                    <span className="mr-15 d-flex align-items-center">
                      <Tooltip
                        title={
                          userProfileData?.FollowersCount
                            ? userProfileData?.FollowersCount?.toLocaleString()
                            : cardData?.FollowersCount
                            ? cardData?.FollowersCount?.toLocaleString()
                            : cardData?.Followers?.toLocaleString()
                        }
                        className="no--wrap"
                      >
                        {getDynamicIconColor("FollowersIcon")}
                        {/* <img
                          src={userFollowers}
                          className="cardList__footer-label"
                          alt="userFollowers"
                        /> */}
                        <span className="pl-1 fontSize-12 text-grayLight">
                          Followers
                        </span>
                        <span
                          className={`cardList__footer-count ${
                            window.location.pathname
                              .toLowerCase()
                              .includes("/commandcenter/screens")
                              ? "dynamic_icon_color"
                              : "blue-text"
                          }`}
                        >
                          {cardData?.FollowersCount >= 0
                            ? kFormatter(cardData?.FollowersCount)
                            : userProfileData?.FollowersCount >= 0
                            ? kFormatter(userProfileData?.FollowersCount)
                            : kFormatter(cardData?.Followers)}
                        </span>
                      </Tooltip>
                    </span>
                  ) : (
                    ""
                  )}

                  {(cardData?.PlatformID === 7 ||
                    cardData?.PlatformID === 30) &&
                  cardData?.IsBrandPost === "User" ? (
                    <>
                      {cardData?.Rating >= 0 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <Rate
                            disabled
                            value={
                              cardData?.Rating
                                ? cardData?.Rating
                                : cardData?.rating
                            }
                            className="no--wrap w-100 ratingList mr-1 "
                          />
                          {cardData?.Rating}
                        </span>
                      ) : (
                        ""
                      )}

                      {cardData?.PlatformID === 7 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <span
                            className="w-100 text-ellipsis mr-1"
                            style={{ color: "blue" }}
                          >
                            App Version:
                          </span>
                          {cardData?.App_version === "NA" ? (
                            <>
                              <i
                                className={`fa fa-minus cursor-pointer ml-1 fontSize-12 ${
                                  window.location.pathname
                                    .toLowerCase()
                                    ?.includes("/commandcenter/screens")
                                    ? "dynamic_icon_color"
                                    : "text-gray"
                                }`}
                              />
                              <Tooltip
                                title="Version information is not available for this review."
                                placement="top"
                                className="text-ellipsis d-inline-block wm-chart-card-title"
                              >
                                <i
                                  className={`fa fa-info-circle cursor-pointer ml-1 ${
                                    window.location.pathname
                                      .toLowerCase()
                                      ?.includes("/commandcenter/screens")
                                      ? "dynamic_icon_color"
                                      : "text-gray"
                                  }`}
                                  style={{ overflow: "visible" }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            cardData?.App_version
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                      {cardData?.PlatformID === 7 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <img
                            src={androidImage}
                            alt="Android Image"
                            className="profileImg ml-1 mr-1"
                            style={{ width: "1.5rem" }}
                          />
                          {cardData?.Android_version}
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {cardData?.PlatformID === 7 &&
                cardData?.IsBrandPost === "User" ? (
                  <span className="ml-15 mb-5 d-flex align-items-center">
                    <span className="d-flex w-100">
                      <span
                        className="text-ellipsis mr-1"
                        style={{ color: "blue" }}
                      >
                        Device Name:
                      </span>
                      <span className="text-ellipsis">{cardData?.Device}</span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
                {/* Additional for E-Commerce channel */}
                {cardData?.PlatformID === 14 ? (
                  <span className="ml-15 mb-10 d-flex align-items-center">
                    <span className="w-100">
                      <span
                        className={
                          authParams?.screen_id && !isDeepDiveDashboardView
                            ? "color-white"
                            : ""
                        }
                      >
                        Title :
                      </span>
                      <span
                        className={
                          authParams?.screen_id && !isDeepDiveDashboardView
                            ? "color-white font-weight800"
                            : "font-weight800"
                        }
                      >
                        {" "}
                        {getTextWithWrapHtml(
                          cardData?.Title !== "" &&
                            cardData?.Title !== "NA" &&
                            cardData?.Title
                            ? cardData?.Title
                            : "NA",
                          "",
                          highlightWord
                        )}
                      </span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
                {cardData?.PlatformID === 14 ? (
                  <span className="ml-15 mb-10 d-flex align-items-center">
                    <span className="w-100 " style={{}}>
                      <span
                        className={
                          authParams?.screen_id && !isDeepDiveDashboardView
                            ? "color-white"
                            : ""
                        }
                      >
                        Product Name :
                      </span>
                      <span
                        className={
                          authParams?.screen_id && !isDeepDiveDashboardView
                            ? "color-white font-weight800"
                            : "font-weight800"
                        }
                      >
                        {" "}
                        {getTextWithWrapHtml(
                          cardData?.ProductName !== "" &&
                            cardData?.ProductName !== "NA" &&
                            cardData?.ProductName
                            ? cardData?.ProductName
                            : "NA",
                          "",
                          highlightWord
                        )}
                      </span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
                <PostAttachment
                  el={cardData}
                  // i={i}
                  // PdfDownloadStatus={PdfDownloadStatus}
                  // PptGeneratingStatus={PptGeneratingStatus}
                  // data={data}
                  // isPreviewState={isPreviewState}
                  trendView={true}
                  postText={
                    cardData?.mention_text
                      ? cardData?.mention_text
                      : cardData?.PostText
                  }
                  pantipChannel={pantipChannel}
                  section_index={section_index}
                  widget_index={widget_index}
                  highlightWord={highlightWord}
                  isDeepDiveDashboardView={isDeepDiveDashboardView}
                />
                {cardData?.EmailContentHtml !== "NA" &&
                  cardData?.EmailContentHtml && (
                    <QuotedPost
                      el={cardData?.EmailContentHtml}
                      // i={i}
                      PdfDownloadStatus={PdfDownloadStatus}
                      PptGeneratingStatus={PptGeneratingStatus}
                      trendView={true}
                      isDeepDiveDashboardView={isDeepDiveDashboardView}
                    />
                  )}
                {cardData?.post_label &&
                Array.isArray(cardData?.post_label) &&
                cardData?.post_label?.length > 0 ? (
                  <div className="ner-attribute p-15 pb-0 m-0">
                    <div className="text_regular font-weight500">
                      {cardData?.post_label?.length > 1 ? "Labels:" : "Label:"}
                    </div>
                    <PostLabels pills={cardData?.post_label} />
                  </div>
                ) : (
                  ""
                )}
                <div
                  className={`p-15 d-flex align-items-center  ${
                    cardData?.PlatformID === 7 || cardData?.PlatformID === 30
                      ? "justify-content-end"
                      : "justify-content-between"
                  } ${pantipChannel ? "flex-wrap" : ""}`}
                >
                  {cardData?.PlatformID !== 7 &&
                  cardData?.PlatformID !== 30 &&
                  !pantipChannel ? (
                    <div className="w-100">
                      <span className="mr-15">
                        <Tooltip
                          title={`${
                            (cardData?.PlatformID === 36
                              ? "Upvotes"
                              : "Likes") +
                            ": " +
                            cardData?.NumLikesCount?.toLocaleString()
                          }`}
                        >
                          <span className="cursor-pointer">
                            {cardData?.PlatformID === 2 ||
                            cardData?.PlatformID === 4
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("facebook_like_white")
                                : getDynamicChannelIcon("facebook_like")
                              : cardData?.PlatformID === 36
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("upvote_white")
                                : getDynamicChannelIcon("upvote")
                              : authParams?.theme_type === "1"
                              ? getDynamicChannelIcon("like_white_icon")
                              : getDynamicChannelIcon("like_icon")}

                            <span className="cardList__footer-count text-Darkgray">
                              {kFormatter(cardData?.NumLikesCount)}
                            </span>
                          </span>
                        </Tooltip>
                      </span>
                      {authParams?.screen_id === "000-000-554" &&
                      !isDeepDiveDashboardView ? (
                        ""
                      ) : (
                        <span className="mr-15">
                          <Tooltip
                            title={`${
                              (cardData?.PlatformID === 36
                                ? "Answers"
                                : cardData?.PlatformID === 1
                                ? "Replies"
                                : "Comments") +
                              ": " +
                              (cardData?.PlatformID === 36
                                ? cardData?.AnswerCount?.toLocaleString()
                                : cardData?.NumCommentsCount?.toLocaleString())
                            }`}
                          >
                            <span className="cursor-pointer">
                              {authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("comment_white_icon")
                                : getDynamicChannelIcon("comment_icon")}

                              <span className="cardList__footer-count text-Darkgray">
                                {cardData?.PlatformID === 36
                                  ? kFormatter(cardData?.AnswerCount)
                                  : kFormatter(cardData?.NumCommentsCount)}
                              </span>
                            </span>
                          </Tooltip>
                        </span>
                      )}
                      {(cardData?.PlatformID !== 3 ||
                        (cardData?.PlatformID === 3 &&
                          cardData?.card_type === "Brand Post") ||
                        (cardData?.card_type === "User Post" &&
                          cardData?.PlatformID !== 21 &&
                          cardData?.PlatformID !== 70 &&
                          cardData?.PlatformID !== 22)) && (
                        <Tooltip
                          title={`${
                            (cardData?.PlatformID === 1
                              ? "Retweets & Quoted Tweets"
                              : "Shares") +
                            ": " +
                            cardData?.NumShareCount?.toLocaleString()
                          }`}
                        >
                          <span className="cursor-pointer">
                            {cardData?.PlatformID === 2
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("facebook_share_white")
                                : getDynamicChannelIcon("facebook_share")
                              : cardData?.PlatformID === 4 ||
                                cardData?.PlatformID === 5
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("youtube_share_white")
                                : getDynamicChannelIcon("youtube_share")
                              : cardData?.PlatformID === 1
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("retweet_white_icon")
                                : getDynamicChannelIcon("retweet_icon")
                              : cardData?.PlatformID === 36
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("share_q_white_icon")
                                : getDynamicChannelIcon("share_q_icon")
                              : cardData?.PlatformID === 3
                              ? authParams?.theme_type === "1"
                                ? getDynamicChannelIcon("instagram_share_white")
                                : getDynamicChannelIcon("instagram_share")
                              : authParams?.theme_type === "1"
                              ? getDynamicChannelIcon("youtube_share_white")
                              : getDynamicChannelIcon("youtube_share")}

                            <span className="cardList__footer-count text-Darkgray">
                              {kFormatter(cardData?.NumShareCount)}
                            </span>
                          </span>
                        </Tooltip>
                      )}
                      {authParams?.screen_id !== "000-000-554" &&
                        (cardData?.MediaType === 3 ||
                          cardData?.NumVideoViews > 0 ||
                          cardData?.PlatformID === 36) && (
                          <Tooltip
                            title={`${
                              "Views: " +
                              cardData?.NumVideoViews?.toLocaleString()
                            }`}
                          >
                            <span className="ml-15 cursor-pointer">
                              <img
                                src={
                                  (cardData?.MediaType === 3 ||
                                    cardData?.NumVideoViews > 0 ||
                                    cardData?.PlatformID === 36) &&
                                  authParams?.theme_type === "1"
                                    ? Video_view_white
                                    : Video_view
                                }
                                className="cardList__footer-label"
                                alt="Video_view"
                              />
                              <span className="cardList__footer-count text-Darkgray">
                                {kFormatter(cardData?.NumVideoViews)}
                              </span>
                            </span>
                          </Tooltip>
                        )}

                      {/* Show For Only TikTok Channel */}
                      {cardData?.PlatformID === 37 &&
                      cardData?.SavedCount >= 0 &&
                      cardData?.SavedCount !== "NA" &&
                      cardData?.SavedCount !== null ? (
                        <Tooltip
                          title={`${
                            "Saved Count: " +
                            cardData?.SavedCount?.toLocaleString()
                          }`}
                        >
                          <span className="ml-15 cursor-pointer">
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? white_Saved
                                  : saved
                              }
                              className="cardList__footer-label"
                              alt="saved"
                            />
                            <span className="cardList__footer-count text-Darkgray">
                              {kFormatter(cardData?.SavedCount)}
                            </span>
                          </span>
                        </Tooltip>
                      ) : (
                        ""
                      )}

                      {/* Show For Only Instagram Channel */}
                      {cardData?.PlatformID === 3 &&
                      cardData?.SavedCount >= 0 &&
                      cardData?.SavedCount !== "NA" &&
                      cardData?.SavedCount !== null ? (
                        <Tooltip
                          title={`${
                            "Post Saves: " +
                            cardData?.SavedCount?.toLocaleString()
                          }`}
                        >
                          <span className="ml-15 cursor-pointer">
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? white_Saved
                                  : saved
                              }
                              className="cardList__footer-label"
                              alt="saved"
                            />
                            <span className="cardList__footer-count text-Darkgray">
                              {kFormatter(cardData?.SavedCount)}
                            </span>
                          </span>
                        </Tooltip>
                      ) : (
                        ""
                      )}

                      {/* Ad Spend Display */}
                      {cardData?.ad_cost &&
                        cardData?.ad_cost > 0 &&
                        cardData?.ADCostInfoText && (
                          <Tooltip title={cardData?.ADCostInfoText}>
                            <span className="ml-15 cursor-pointer">
                              <img
                                src={
                                  authParams?.theme_type === "1"
                                    ? moneyBagIconWhite
                                    : moneyBagIcon
                                }
                                className="cardList__footer-label"
                                alt="Ad Spend"
                                style={{ width: "1.5rem", height: "1.5rem" }}
                              />
                              <span className="cardList__footer-count text-Darkgray">
                                {cardData?.ad_currency &&
                                cardData?.ad_currency !== "NA"
                                  ? `${cardData?.ad_currency} ${kFormatter(
                                      cardData?.ad_cost
                                    )}`
                                  : kFormatter(cardData?.ad_cost)}
                              </span>
                            </span>
                          </Tooltip>
                        )}

                      {(cardData?.PlatformID === 2 ||
                        cardData?.PlatformID === 5) &&
                        cardData?.Posttype === "Brand Post" &&
                        cardData?.post_clicks >= 0 && (
                          <Tooltip
                            title={`${
                              "Post Clicks: " +
                              cardData?.post_clicks?.toLocaleString()
                            }`}
                            // className="mr-15 d-inline-flex align-items-center"
                          >
                            <span className="ml-15 cursor-pointer">
                              <img
                                src={
                                  authParams?.theme_type === "1"
                                    ? postClickWhite
                                    : postClickBlack
                                }
                                className="cardList__footer-label"
                                alt="Post Clicks"
                                style={{ width: "1.6rem", height: "1.6rem" }}
                              />
                              <span
                                // style={{ marginTop: "0.7rem" }}
                                className="cardList__footer-count text-Darkgray"
                              >
                                {kFormatter(cardData?.post_clicks)}
                              </span>
                            </span>
                          </Tooltip>
                        )}
                    </div>
                  ) : pantipChannel ? (
                    <div
                      className={`d-flex no--wrap flex-wrap card__footer__pantipStatsWrapper trendsView`}
                    >
                      {workspace_privileges?.environment === 2 ||
                      share_workspace_privileges?.environment === 2 ? (
                        <>
                          <Tooltip
                            title={`${
                              "Points" +
                              ": " +
                              (cardData?.PantipPoint || 0)?.toLocaleString()
                            }`}
                            className="d-inline-flex align-items-center"
                          >
                            <div className="cursor-pointer">
                              <div className={`${"cardList__footer-label"}`}>
                                {" "}
                                {authParams?.theme_type === "1"
                                  ? getDynamicChannelIcon(
                                      "pantip_point_white_icon"
                                    )
                                  : getDynamicChannelIcon("pantip_point_icon")}
                              </div>
                              <span
                                className={`${"cardList__footer-count text-Darkgray"}`}
                              >
                                {kFormatter(cardData?.PantipPoint || 0)}
                              </span>
                            </div>
                          </Tooltip>
                        </>
                      ) : (
                        ""
                      )}
                      <Tooltip
                        title={`${
                          "Likes" +
                          ": " +
                          (cardData?.LikeCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          <div className={`${"cardList__footer-label"}`}>
                            {" "}
                            {authParams?.theme_type === "1"
                              ? getDynamicChannelIcon("pantip_like_white_icon")
                              : getDynamicChannelIcon("pantip_like_icon")}
                          </div>
                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.LikeCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={`${
                          "Laugh" +
                          ": " +
                          (cardData?.LaughCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          {authParams?.theme_type === "1"
                            ? getDynamicChannelIcon("pantip_laugh_white_icon")
                            : getDynamicChannelIcon("pantip_laugh_icon")}

                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.LaughCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={`${
                          "Love" +
                          ": " +
                          (cardData?.LoveCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          {authParams?.theme_type === "1"
                            ? getDynamicChannelIcon("pantip_love_white_icon")
                            : getDynamicChannelIcon("pantip_love_icon")}

                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.LoveCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={`${
                          "Impress" +
                          ": " +
                          (cardData?.ImpressCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          {authParams?.theme_type === "1"
                            ? getDynamicChannelIcon("pantip_impress_white_icon")
                            : getDynamicChannelIcon("pantip_impress_icon")}

                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.ImpressCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={`${
                          "Scary" +
                          ": " +
                          (cardData?.ScaryCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          {authParams?.theme_type === "1"
                            ? getDynamicChannelIcon("pantip_scary_white_icon")
                            : getDynamicChannelIcon("pantip_scary_icon")}

                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.ScaryCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={`${
                          "Wow" +
                          ": " +
                          (cardData?.WowCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          {authParams?.theme_type === "1"
                            ? getDynamicChannelIcon("pantip_wow_white_icon")
                            : getDynamicChannelIcon("pantip_wow_icon")}

                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.WowCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={`${
                          "Comments" +
                          ": " +
                          (cardData?.NumCommentsCount || 0)?.toLocaleString()
                        }`}
                        className={`d-inline-flex align-items-center`}
                      >
                        <div className="cursor-pointer">
                          {authParams?.theme_type === "1"
                            ? getDynamicChannelIcon("pantip_comment_white_icon")
                            : getDynamicChannelIcon("pantip_comment_icon")}

                          <span
                            className={`${"cardList__footer-count text-Darkgray"}`}
                          >
                            {kFormatter(cardData?.NumCommentsCount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                      {(workspace_privileges?.environment === 2 ||
                        share_workspace_privileges?.environment === 2) &&
                      cardData?.Engagement >= 0 ? (
                        <Tooltip
                          title={`${
                            "Engagement" +
                            ": " +
                            cardData?.Engagement?.toLocaleString()
                          }`}
                          className="d-inline-flex align-items-center"
                        >
                          <div className="cursor-pointer">
                            <div className="text_regular white-space-nowrap mr-1">
                              Engagement
                            </div>
                            {cardData?.engagement_fx ? (
                              <Tooltip title={cardData?.Engagement_text}>
                                {" ( "}
                                <img
                                  src={fx}
                                  style={{ maxWidth: "15px" }}
                                  className="cursor-pointer"
                                  alt="fx"
                                />
                                {" ) "}
                              </Tooltip>
                            ) : (
                              ""
                            )}
                            <span
                              className={`${"cardList__footer-count text-Darkgray"} ${
                                !cardData?.engagement_fx ? "ml-0" : ""
                              }`}
                            >
                              {": "}
                              {kFormatter(cardData?.Engagement)}
                            </span>
                          </div>
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}

                  {/* Ad Spend Display for Pantip */}
                  {pantipChannel &&
                    cardData?.ad_cost &&
                    cardData?.ad_cost > 0 &&
                    cardData?.ADCostInfoText && (
                      <Tooltip
                        title={cardData?.ADCostInfoText}
                        className="d-inline-flex align-items-center mr-2"
                      >
                        <div className="cursor-pointer">
                          <img
                            src={
                              authParams?.theme_type === "1"
                                ? moneyBagIconWhite
                                : moneyBagIcon
                            }
                            className="cardList__footer-label"
                            alt="Ad Spend"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          />
                          <span className="cardList__footer-count text-Darkgray">
                            {cardData?.ad_currency &&
                            cardData?.ad_currency !== "NA"
                              ? `${cardData?.ad_currency} ${kFormatter(
                                  cardData?.ad_cost
                                )}`
                              : kFormatter(cardData?.ad_cost)}
                          </span>
                        </div>
                      </Tooltip>
                    )}

                  {/* Marked Influencers Icon */}
                  {(cardData?.Author
                    ? cardData?.Author !== "Anonymous"
                    : cardData?.AuthorName !== "Anonymous") &&
                  cardData?.InfluencerCategoryID &&
                  cardData?.InfluencerCategoryID !== "NA" &&
                  cardData?.InfluencerCategoryID !== "" &&
                  cardData?.InfluencerCategory &&
                  cardData?.InfluencerCategory !== "NA" &&
                  cardData?.InfluencerCategory !== "" ? (
                    <>
                      <div className="mr-2">
                        <Tooltip
                          title={
                            <div
                              className="custom_scroll"
                              style={{
                                maxWidth: "270px",
                                maxHeight: "230px",
                                overflow: "auto",
                                scrollBehavior: "smooth",
                              }}
                            >
                              {cardData?.InfluencerCategory}
                            </div>
                          }
                        >
                          <img
                            src={MarkInfluencerYellowIcon}
                            className="cardList__footer-label"
                            alt="Marked Influencer Icon"
                          />
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <Tooltip
                    title={
                      cardData?.PostURL &&
                      cardData?.PostURL?.trim() &&
                      cardData?.PostURL !== "NA"
                        ? "Open Post"
                        : "Post URL is not available"
                    }
                  >
                    {cardData?.PostURL &&
                    cardData?.PostURL?.trim() &&
                    cardData?.PostURL !== "NA" ? (
                      <a
                        className={`trands blue-text font-size12 cursor-pointer`}
                        href={cardData?.PostURL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i class={`fas fa-external-link-alt  `} />
                      </a>
                    ) : (
                      <span
                        style={{ display: "inline-block", opacity: "0.4" }}
                        className="blue-text font-size14 mr-2"
                      >
                        <i class={`fas fa-external-link-alt`} />
                      </span>
                    )}
                  </Tooltip>
                </div>
              </div>
              {cardData?.PlatformID !== 7 &&
              cardData?.PlatformID !== 30 &&
              !pantipChannel ? (
                <div className="card-footer flex-wrap justify-content-center d-flex align-items-top pt-2 pb-2 pl-15 pr-15 bg__white text-center">
                  <div
                    style={{ width: "25%" }}
                    className="card-footer--innnerWrap"
                  >
                    <div className="text_regular text-grayLight">
                      Engagement
                    </div>
                    <div className="text_heading-Rubik font-size18 line-height-normal">
                      <div>
                        <Tooltip title={cardData?.Engagement?.toLocaleString()}>
                          {" "}
                          {kFormatter(cardData?.Engagement)}
                        </Tooltip>{" "}
                      </div>
                      {cardData?.PlatformID === 3 &&
                      cardData?.isPromoted === 5 ? (
                        <Tooltip
                          title={
                            "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                          }
                        >
                          <img
                            src={InfoIconYellow}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="info"
                          />
                        </Tooltip>
                      ) : cardData?.engagement_fx ? (
                        <Tooltip title={cardData?.Engagement_text}>
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div
                    style={{ width: "25%" }}
                    className="card-footer--innnerWrap"
                  >
                    <div
                      className={`text_regular text-grayLight cursor-pointer`}
                    >
                      <Tooltip title="Engagement Rate">Eng. Rate</Tooltip>
                    </div>
                    <div className="text_heading-Rubik font-size18 line-height-normal">
                      <div>
                        <Tooltip
                          title={cardData?.Engagement_rate?.toLocaleString()}
                        >
                          {" "}
                          {kFormatter(cardData?.Engagement_rate)}
                        </Tooltip>{" "}
                      </div>
                      {cardData?.Engagement_rate_fx ? (
                        <Tooltip title={cardData?.Engagement_rate_text}>
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div
                    style={{ width: "25%" }}
                    className="card-footer--innnerWrap"
                  >
                    <div
                      className={`text_regular text-grayLight ${
                        cardData?.reach_fx ? "cursor-pointer" : ""
                      }`}
                    >
                      {cardData?.reach_fx ? (
                        <Tooltip title="Estimated Reach">Est. Reach</Tooltip>
                      ) : (
                        "Reach"
                      )}
                    </div>
                    <div className="text_heading-Rubik font-size18 line-height-normal">
                      <div>
                        {" "}
                        <Tooltip title={cardData?.Reach?.toLocaleString()}>
                          {" "}
                          {kFormatter(cardData?.Reach)}
                        </Tooltip>{" "}
                      </div>
                      {cardData?.reach_fx && (
                        <Tooltip title={cardData?.Reach_text}>
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div
                    style={{ width: "25%" }}
                    className="card-footer--innnerWrap"
                  >
                    <div
                      className={`text_regular text-grayLight ${
                        cardData?.impression_fx ? "cursor-pointer" : ""
                      }`}
                    >
                      {cardData?.impression_fx ? (
                        <Tooltip title="Estimated Impression">
                          Est. Impression
                        </Tooltip>
                      ) : (
                        "Impression"
                      )}
                    </div>
                    <div className="text_heading-Rubik font-size18 line-height-normal">
                      <div>
                        <Tooltip title={cardData?.Impression?.toLocaleString()}>
                          {" "}
                          {kFormatter(cardData?.Impression)}
                        </Tooltip>{" "}
                      </div>
                      {cardData?.impression_fx && (
                        <Tooltip title={cardData?.Impression_text}>
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {cardData?.card_type === "User Post" && (
              <div className="Collapse-div text_regular border-top border-color mt-15">
                <div className="cardList-head border-bottom border-color p-15 card-head text_heading d-flex align-items-center">
                  <Image
                    src={
                      authParams?.screen_id &&
                      !deepDive &&
                      !isDeepDiveDashboardView
                        ? cardData?.picurl === 0 ||
                          cardData?.picurl === "" ||
                          !cardData?.picurl
                          ? Profile
                          : cardData?.picurl
                        : cardData?.ProfilePicture === 0 ||
                          cardData?.ProfilePicture === "" ||
                          !cardData?.ProfilePicture
                        ? Profile
                        : cardData?.ProfilePicture
                    }
                    fallback={Profile}
                    preview={false}
                    alt="Profile Images"
                    className="profileImg mr-1"
                    style={{ width: "2rem", height: "2rem" }}
                  />
                  <div className="d-flex flex-wrap w-100">
                    <Tooltip
                      title={
                        cardData?.Author
                          ? cardData?.Author
                          : cardData?.AuthorName
                      }
                    >
                      {" "}
                      {(cardData?.Author
                        ? cardData?.Author
                        : cardData?.AuthorName) && (
                        <div className="profileName line-height-normal">
                          {cardData?.AuthorURL &&
                          cardData?.AuthorURL !== "NA" ? (
                            <a
                              className={
                                cardData?.AuthorURL &&
                                cardData?.AuthorURL !== "NA"
                                  ? ""
                                  : "pointer-events1 cursor-default"
                              }
                              href={
                                cardData?.AuthorURL &&
                                cardData?.AuthorURL !== "NA"
                                  ? cardData?.AuthorURL
                                  : ""
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {cardData?.Author
                                ? cardData?.Author
                                : cardData?.AuthorName}
                            </a>
                          ) : (
                            <>
                              {cardData?.Author
                                ? cardData?.Author
                                : cardData?.AuthorName}
                            </>
                          )}
                        </div>
                      )}
                    </Tooltip>
                    {(authParams?.screen_id &&
                      !deepDive &&
                      !isDeepDiveDashboardView &&
                      cardData?.isVerified &&
                      cardData?.isVerified !== "NA" &&
                      cardData?.isVerified === "Verified") ||
                    (cardData?.AuthorIsVerified !== "NA" &&
                      cardData?.AuthorIsVerified &&
                      cardData?.AuthorIsVerified > 0) ? (
                      <img
                        src={verified}
                        alt="verified"
                        className="profileImg ml-1"
                        style={{ width: "1.5rem" }}
                      />
                    ) : (
                      ""
                    )}
                    <div className="screenName w-100">
                      {cardData?.UserLocation ? (
                        <i className="fas fa-map-marker-alt mr-1" />
                      ) : (
                        ""
                      )}
                      {cardData?.UserLocation ? cardData?.UserLocation : ""}
                    </div>
                  </div>
                </div>
                <div className="p-15 border-bottom border-color">
                  <div className="d-flex justify-content-between">
                    <div className="mb-15">
                      <b>Gender:</b>
                      <span className="blue_text font-size12 ml-1">
                        {userProfileData?.Gender
                          ? userProfileData?.Gender
                          : "NA"}
                      </span>
                    </div>
                    <div className="mb-15">
                      <b>Age:</b>
                      <span className="text_regular-gray font-size12 ml-1">
                        {!userProfileData?.Age ? "NA" : userProfileData?.Age}
                      </span>
                    </div>
                  </div>
                  <div className="mb-15 text_regular">
                    <b>Influencer:</b>
                    <span className="text_regular-gray ml-1">
                      {userProfileData?.influencercategory ||
                      userProfileData?.influencercategory === "" ||
                      userProfileData?.influencercategory === 0
                        ? userProfileData?.influencercategory === "" ||
                          userProfileData?.influencercategory === 0
                          ? "Not an influencer"
                          : userProfileData?.influencercategory
                        : userProfileData?.InfluencerCategory === "" ||
                          userProfileData?.InfluencerCategory === 0
                        ? "Not an influencer"
                        : userProfileData?.InfluencerCategory}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-15">
                    <div className="text_regular line-height-normal">
                      <b>Sentiment Uplift Score</b>
                      {!(
                        userProfileData?.UpliftLastupdatedDatetime === "NA"
                      ) && (
                        <div className="text_regular-gray font-size12 mt-1">
                          Last Update on{" "}
                          {userProfileData?.UpliftLastupdatedDatetime}
                          {/* <i className="fas fa-redo-alt cursor-pointer ml-2" /> */}
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        color:
                          userProfileData?.UpliftSentimentScore_sentiment_color
                            ? userProfileData?.UpliftSentimentScore_sentiment_color
                            : "",
                      }}
                    >
                      {userProfileData?.UpliftSentimentScore === 0 ? (
                        ""
                      ) : (
                        <i className="fa fa-smile mr-1" />
                      )}
                      {userProfileData?.UpliftSentimentScore === 0
                        ? "NA"
                        : userProfileData?.UpliftSentimentScore}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text_regular line-height-normal">
                      <b>NPS Score</b>{" "}
                      {/* <i className="fas fa-redo-alt cursor-pointer ml-2" /> */}
                    </div>
                    <div
                      style={{
                        color: userProfileData?.NPSScore_sentiment_color
                          ? userProfileData?.NPSScore_sentiment_color
                          : "",
                      }}
                    >
                      {userProfileData?.NPSScore === 0
                        ? "NA"
                        : userProfileData?.NPSScore}
                    </div>
                  </div>
                </div>
                <Collapse
                  accordion
                  bordered={false}
                  expandIconPosition="right"
                  className="bg__white"
                >
                  <Panel header="Profile" key="1" className="border-color">
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        <img
                          src={featherPhone}
                          alt={featherPhone}
                          style={{ maxWidth: "1.2rem" }}
                        />
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.PhoneNumber
                          ? userProfileData?.PhoneNumber
                          : "NA"}{" "}
                        {userProfileData?.PhoneNumber > 0 && (
                          <Tooltip
                            placement="bottom"
                            title={isCopyEmail ? "Number copied" : "Copy"}
                          >
                            <i
                              className="fa fa-clone cursor-pointer"
                              onClick={() =>
                                emailCopy(userProfileData?.PhoneNumber)
                              }
                            />
                          </Tooltip>
                        )}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        <img
                          src={simpleEmail}
                          alt={simpleEmail}
                          className="mr-1"
                          style={{ maxWidth: "1.2rem" }}
                        />
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.EmailID
                          ? userProfileData?.EmailID
                          : "NA"}{" "}
                        {userProfileData?.EmailID > 0 && (
                          <Tooltip
                            placement="bottom"
                            title={isCopyEmail ? "Email copied" : "Copy"}
                          >
                            <img
                              src={featherCopy}
                              alt={featherCopy}
                              className="cursor-pointer ml-1"
                              style={{ maxWidth: "1.5rem" }}
                              onClick={() =>
                                emailCopy(userProfileData?.EmailID)
                              }
                            />
                          </Tooltip>
                        )}
                      </div>
                    </div>
                    <div className="pt-15 border-top border-color">
                      <div className="text_regular-gray ml-1">
                        <img
                          src={
                            cardData?.PlatformID === 0
                              ? Default_Brand
                              : SocialMedialogo?.[cardData?.PlatformID]
                              ? SocialMedialogo?.[cardData?.PlatformID]
                              : Default_Brand
                          }
                          alt="Channel"
                          style={{ maxWidth: "2rem", maxHeight: "2rem" }}
                        />{" "}
                        {userProfileData?.Author}
                      </div>
                      <ul className="pl-0 profile_lists">
                        <li
                          style={{
                            color:
                              cardData?.PlatformID === 0
                                ? Default_Brand
                                : cardData?.PlatformID === 1
                                ? "#1da1f2"
                                : cardData?.PlatformID === 2
                                ? "#3b5998"
                                : cardData?.PlatformID === 3 ||
                                  cardData?.PlatformID === 37
                                ? "#C13584"
                                : cardData?.PlatformID === 4
                                ? "#FF0000"
                                : cardData?.PlatformID === 5 && "#0A66C2",
                          }}
                        >
                          <span className="font-weight400 text_regular-gray">
                            {cardData?.PlatformID === 1
                              ? "Followers :"
                              : cardData?.PlatformID === 2
                              ? "Friends"
                              : cardData?.PlatformID === 3 ||
                                cardData?.PlatformID === 37 ||
                                cardData?.PlatformID === 43
                              ? "Followers :"
                              : cardData?.PlatformID === 4
                              ? "Subscribers :"
                              : cardData?.PlatformID === 5 && "Connections :"}
                          </span>{" "}
                          <span className="font-weight500 text_regular">
                            {userProfileData?.FollowersCount?.toLocaleString()}
                          </span>
                        </li>
                        {cardData?.PlatformID === 2 ||
                        cardData?.PlatformID === 4 ? (
                          ""
                        ) : (
                          <li
                            style={{
                              color:
                                cardData?.PlatformID === 0
                                  ? Default_Brand
                                  : cardData?.PlatformID === 1
                                  ? "#1da1f2"
                                  : cardData?.PlatformID === 2
                                  ? "#3b5998"
                                  : cardData?.PlatformID === 3 ||
                                    cardData?.PlatformID === 37
                                  ? "#C13584"
                                  : cardData?.PlatformID === 4
                                  ? "#FF0000"
                                  : cardData?.PlatformID === 5 && "#0A66C2",
                            }}
                          >
                            <span className="font-weight400 text_regular-gray">
                              {cardData?.PlatformID === 1
                                ? "Following :"
                                : cardData?.PlatformID === 3 ||
                                  cardData?.PlatformID === 37 ||
                                  cardData?.PlatformID === 43
                                ? "Following :"
                                : cardData?.PlatformID === 5 && "Following :"}
                            </span>{" "}
                            <span className="font-weight500 text_regular">
                              {userProfileData?.FollowingCount?.toLocaleString()}
                            </span>
                          </li>
                        )}
                        {cardData?.PlatformID === 1 ? (
                          <li
                            style={{
                              color:
                                cardData?.PlatformID === 0
                                  ? Default_Brand
                                  : cardData?.PlatformID === 1
                                  ? "#1da1f2"
                                  : cardData?.PlatformID === 2
                                  ? "#3b5998"
                                  : cardData?.PlatformID === 3 ||
                                    cardData?.PlatformID === 37
                                  ? "#C13584"
                                  : cardData?.PlatformID === 4
                                  ? "#FF0000"
                                  : cardData?.PlatformID === 5 && "#0A66C2",
                            }}
                          >
                            <span className="font-weight400 text_regular-gray">
                              {cardData?.PlatformID === 1
                                ? "Tweets :"
                                : cardData?.PlatformID === 2
                                ? "Posts :"
                                : cardData?.PlatformID === 3 ||
                                  cardData?.PlatformID === 37 ||
                                  cardData?.PlatformID === 43
                                ? "Posts :"
                                : cardData?.PlatformID === 4
                                ? "Videos :"
                                : cardData?.PlatformID === 5 && "Post :"}
                            </span>{" "}
                            <span className="font-weight500 text_regular">
                              {userProfileData?.TweetCount?.toLocaleString()}
                            </span>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                    <div className="pt-15 border-top border-color">
                      <div className="mb-2">
                        <div className="font-weight500 text_regular mb-1">
                          Bio
                        </div>
                        <div className="text_regular-gray">
                          {cardData?.AuthorBio ? cardData?.AuthorBio : "NA"}
                        </div>
                      </div>
                      <div className="mb-2">
                        <div className="font-weight500 text_regular mb-1">
                          Traits
                        </div>
                        <div className="text_regular-gray">
                          {userProfileData?.Trait > 0
                            ? userProfileData?.Trait?.map((el, i) => (
                                <span className="border border-color line-height-normal border-radius-16 bg__gray pt-1 pb-1 pl-2 pr-2 mr-1 mb-1">
                                  {el}
                                </span>
                              ))
                            : "NA"}
                        </div>
                      </div>
                    </div>
                  </Panel>
                  <Panel header="CRM Details" key="2" className="border-color">
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">DOB: </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.DateOfBirth > 0
                          ? userProfileData?.DateOfBirth
                          : "NA"}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        Contact Number:{" "}
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.PhoneNumber > 0
                          ? userProfileData?.PhoneNumber
                          : "NA"}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        Alternate Number:{" "}
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.alternate_no
                          ? userProfileData?.alternate_no
                          : "NA"}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        Pan card No:{" "}
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.IsPanCardAvailable > 0
                          ? "As"
                          : "Hidden"}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        Aadhaar card No:{" "}
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.IsAadharCardAvailable > 0
                          ? "As"
                          : "Hidden"}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-15">
                      <div className="font-weight500 text_regular">
                        Address:{" "}
                      </div>
                      <div className="text_regular-gray ml-1">
                        {userProfileData?.Address > 0
                          ? userProfileData?.Address
                          : "NA"}
                      </div>
                    </div>
                    {(userProfileData?.pref_lang ||
                      userProfileData?.pref_lang > 0) && (
                      <div className="d-flex align-items-center">
                        <div className="font-weight500 text_regular">
                          Pref Lang:{" "}
                        </div>
                        <div className="text_regular-gray ml-1">
                          {userProfileData?.pref_lang
                            ? userProfileData?.pref_lang
                            : "NA"}
                        </div>
                      </div>
                    )}
                  </Panel>
                </Collapse>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-12 col-md-8 pl-0 pr-0">
        <div
          className="trends_tabs text_heading d-flex align-items-center font-weight500 fontSize-16 pl-15 pt-2 pb-2 border-bottom border-color"
          style={{ height: "5rem" }}
        >
          <Button
            className={`trends_tabs-list cursor-pointer ${
              sectionActive === "reactions" ? "active" : ""
            }`}
            id="element_user_reactions"
            style={{ display: "inline-block" }}
            onClick={() => accoArrowDw("reactions", "top")}
          >
            User Reactions
          </Button>

          {
            // (cardData?.card_type === "Brand Post" &&
            //   cardData?.PlatformID === 3) ||
            cardData?.card_type === "User Post" &&
            //cardData?.PlatformID === 3 ||
            (cardData?.PlatformID === 2 || cardData?.PlatformID === 36) ? (
              ""
            ) : (
              <Button
                className={`trends_tabs-list cursor-pointer ${
                  sectionActive === "profiles" ? "active" : ""
                }`}
                id="element_engaged_profiles_data"
                style={{ display: "inline-block" }}
                onClick={() => accoArrowDw("profiles", "top")}
              >
                Profiles
              </Button>
            )
          }
          {cardData?.PlatformID === 1 && (
            <Button
              className={`trends_tabs-list cursor-pointer ${
                sectionActive === "maps" ? "active" : ""
              }`}
              id="element_retweet_map"
              style={{ display: "inline-block" }}
              onClick={() => accoArrowDw("maps", "top")}
            >
              Maps
            </Button>
          )}
        </div>
        <div
          className="TrendsViewContainer bg__gray custom_scroll1 p-15"
          style={{ height: "calc(100vh - 5.1rem)", overflow: "auto" }}
          id="TreandsChartsContainer"
          onScroll={(e) => handelScroll(e)}
        >
          <Element
            id="element_user_reactions"
            name="element_user_reactions"
            key="element_user_reactions"
            onClick={() => accoArrowDw("reactions")}
            // style={{
            //   backgroundColor:
            //     authParams?.theme_type === "1"
            //       ? "rgb(59 81 117 / 50%)"
            //       : "rgba(255, 255, 255, 0.3)",
            // }}
            className={`section-title trends p-10 ${
              authParams?.theme_type === "1" ? "" : "border"
            } border-color border-radius-4 cursor-pointer mb-15 d-flex align-items-center justify-content-between`}
          >
            <div className="text_heading-Slab font-size16 font-weight500 d-flex align-items-center">
              User Reactions
            </div>
            <img
              src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
              alt="arrow"
              className="accordionArrow"
              style={{
                transform: `rotate(${
                  accordion?.[0]?.value && accordion?.[0]?.id === 1
                    ? "0deg"
                    : "180deg"
                })`,
              }}
            />
          </Element>

          {chartFinalData?.map((el, i) => {
            if (
              el?.chart_type === "kpi" ||
              el?.chart_type === "wordcloud" ||
              el?.chart_type === "donut" ||
              el?.chart_type === "line"
            ) {
              return (
                <div className="trends" id="element_user_reactions">
                  {i === 2 &&
                    (cardData?.card_type === "User Comment" ||
                      cardData?.card_type === "Brand Comment") && (
                      <div
                        className="portlet1 d-flex align-items-center mb-15 border-radius-4"
                        style={{ borderTop: "0.5rem solid #AC52FF" }}
                      >
                        <img src={ParentPost} alt="Parent Post icon" />
                        <div className="ml-15">
                          <div className="font-weight500 text_regular">
                            Parent post activity below
                          </div>
                          <div className="text_regular-gray">
                            All the activities of parent posts can be seen in
                            the detail view below
                          </div>
                        </div>
                      </div>
                    )}

                  <div
                    className={`portlet1 p-0 border border-color border-radius-4 ${
                      accordion?.[0]?.value && accordion?.[0]?.id === 1
                        ? "mb-15"
                        : "d-none"
                    } ${
                      i === chartFinalData?.length - 1 &&
                      (el?.data?.data ===
                        "No data available for selected post" ||
                        el?.widget_loader)
                        ? ""
                        : i === chartFinalData?.length - 1 &&
                          chartFinalData?.length === 5
                        ? "mb-15"
                        : " mb-15"
                    }`}
                  >
                    <div className="text_heading p-15 font-weight500 fontSize-16 border-bottom d-flex justify-content-between align-items-center">
                      {el?.chart_type === "kpi" ? (
                        <div>Detail View</div>
                      ) : el?.chart_type === "line" ? (
                        <div>
                          User Activities Trend{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "wordcloud" ? (
                        <div>
                          Post Wordcloud{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "retweet_map" ? (
                        <div>
                          Retweet Map{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "engaged_profiles_data" ? (
                        <div>
                          Engaged User Profiles{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "reply_map" ? (
                        <div>
                          Reply Map{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : (
                        el?.chart_type === "donut" && (
                          <div>
                            Sentiment Distribution{" "}
                            {(cardData?.card_type === "User Comment" ||
                              cardData?.card_type === "Brand Comment") && (
                              <span className="trands_post_pills">
                                Parent Post{" "}
                              </span>
                            )}
                          </div>
                        )
                      )}
                      {el?.chart_type === "line" && (
                        <div className="d-inline-flex align-items-center">
                          <div className="text_regular font-weight500 mr-2">
                            Duration
                          </div>
                          <Select
                            defaultValue={durationSelect}
                            onChange={handleDurationChange}
                            style={{ minWidth: "13rem" }}
                            className="border-color border-radius-4"
                            dropdownClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Option value="eight_hours">First 8 Hours</Option>
                            <Option value="sixteen_hours">
                              First 16 Hours
                            </Option>
                            <Option value="twenty_four_hours">
                              First 24 Hours
                            </Option>
                            <Option value="thirty_six_hours">
                              First 36 Hours
                            </Option>
                            <Option value="seven_days">First 7 Days</Option>
                            <Option value="thirty_days">First 30 Days</Option>
                            <Option value="ninety_days">First 90 Days</Option>
                            <Option value="six_months">First 6 Months</Option>
                            <Option value="one_year">First 1 Year</Option>
                            <Option value="lifetime">Lifetime</Option>
                          </Select>
                        </div>
                      )}
                    </div>
                    {el?.widget_loader ? (
                      <div
                        className="loader widget_trends"
                        id={el?.widget_id}
                        style={{ height: "30rem" }}
                      >
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    ) : el?.data &&
                      el?.data?.data !==
                        "No data available for selected post" ? (
                      <div className="widget_trends" id={el?.widget_id}>
                        <ErrorBoundary>
                          <GraphList
                            widgetMakerGraphData={el?.data}
                            single={el?.data?.data}
                            style={chart__styles}
                            type={el?.chart_type}
                            trends={true}
                            xaxis={el?.data?.trace_name_xaxis}
                            yaxis={el?.data?.trace_name_yseries}
                          />
                        </ErrorBoundary>

                        {/* <EngagedCard data={el?.data?.data}/> */}
                      </div>
                    ) : (
                      <>
                        <div
                          className="d-flex mb-15 align-items-center justify-content-center"
                          style={{ minHeight: "30rem" }}
                        >
                          <ErrorBoundary>
                            <NoGraphData
                              errorCode="No Data Found"
                              isCommandCenterScreen={
                                authParams?.screen_id &&
                                !isDeepDiveDashboardView
                              }
                            />
                          </ErrorBoundary>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            } else return null;
          })}
          {
            // (cardData?.card_type === "Brand Post" &&
            //   cardData?.PlatformID === 3) ||
            cardData?.card_type === "User Post" &&
            //cardData?.PlatformID === 3  ||
            (cardData?.PlatformID === 2 || cardData?.PlatformID === 36) ? (
              ""
            ) : (
              <Element
                id="engaged_user_profiles"
                name="engaged_user_profiles"
                onClick={() => accoArrowDw("profiles")}
                // style={{
                //   backgroundColor:
                //     authParams?.theme_type === "1"
                //       ? "rgb(59 81 117 / 50%)"
                //       : "rgba(255, 255, 255, 0.3)",
                // }}
                className={`section-title trends p-10 ${
                  authParams?.theme_type === "1" ? "" : "border"
                } border-color border-radius-4 cursor-pointer mb-15 d-flex align-items-center justify-content-between`}
              >
                <div className="text_heading-Slab font-size16 font-weight500">
                  Profiles
                </div>
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="arrow"
                  className="accordionArrow"
                  style={{
                    transform: `rotate(${
                      accordion?.[1]?.value && accordion?.[1]?.id === 2
                        ? "0deg"
                        : "180deg"
                    })`,
                  }}
                />
              </Element>
            )
          }
          {chartFinalData?.map((el, i) => {
            if (el?.chart_type === "engaged_profiles_data") {
              return (
                <div className="trends" id="engaged_user_profiles">
                  <div
                    ref={engagedRef}
                    className={`portlet1 p-0 border border-color border-radius-4 ${
                      accordion?.[1]?.value && accordion?.[1]?.id === 2
                        ? ""
                        : "d-none"
                    } ${
                      i === chartFinalData?.length - 1 &&
                      (el?.data?.data ===
                        "No data available for selected post" ||
                        el?.widget_loader)
                        ? "mb-15"
                        : i === chartFinalData?.length - 1
                        ? "mb-15"
                        : "mb-15"
                    }`}
                  >
                    <div className="border-bottom d-flex justify-content-between p-15">
                      <div className="text_heading font-weight500 fontSize-16">
                        Engaged User Profiles
                        {(cardData?.card_type === "User Comment" ||
                          cardData?.card_type === "Brand Comment") && (
                          <span className="trands_post_pills ml-1">
                            Parent Post{" "}
                          </span>
                        )}
                      </div>

                      <div>
                        <Popover
                          content={menuEngaged}
                          title={null}
                          trigger="click"
                          visible={isOpen}
                          onVisibleChange={handleOpenChange}
                          placement="bottomRight"
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <Button
                            className="cursor-pointer pl-2 pr-2 text_regular engaged_profile-btn border-color justify-content-between align-items-center d-inline-flex"
                            onClick={(e) => e.preventDefault()}
                            style={{ minWidth: "16rem" }}
                          >
                            {checkAll ? (
                              "All"
                            ) : checkedList.length > 1 ? (
                              <span>
                                {checkedList[0]}{" "}
                                <span className="text-gray">
                                  +{checkedList.length - 1}
                                </span>
                              </span>
                            ) : checkedList.length === 1 ? (
                              checkedList[0]
                            ) : (
                              "Not Selected"
                            )}{" "}
                            <i className="fa fa-angle-down ml-1" />
                          </Button>
                        </Popover>
                        <Popover
                          content={sortingMenu}
                          title={null}
                          placement="bottomRight"
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <Button
                            className="p-0 shadow-none border-0 ml-15"
                            style={{
                              paddingLeft: "1.2rem",
                              backgroundColor: "transparent",
                            }}
                          >
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? sortingIconWhite
                                  : sortingIcon
                              }
                              alt="Sorting Icon"
                              className="cursor-pointer"
                            />
                          </Button>
                        </Popover>
                      </div>
                    </div>
                    {el?.widget_loader ? (
                      <div className="loader" style={{ height: "30rem" }}>
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    ) : el?.data &&
                      el?.data?.data !==
                        "No data available for selected post" ? (
                      <div
                        className="p-15 pr-2 widget_trends bg__gray"
                        id={el?.widget_id}
                      >
                        <StackGrid
                          className="trends"
                          id="engaged_user_profiles"
                          gridRef={(r) => (grid.current = r)}
                          columnWidth={
                            width <= 1280
                              ? "50%"
                              : width <= 768
                              ? "100%"
                              : "33%"
                          }
                        >
                          {el?.data?.data?.map((engaged, i) => {
                            return <EngagedCard data={engaged} />;
                          })}
                        </StackGrid>

                        {el?.data?.data &&
                          el?.data?.data.length > 0 &&
                          el?.data?.noOfPages > 1 && (
                            <div className="text-right widgetLibraryPagination pr-15 pt-15">
                              <Pagination
                                pageSize={12}
                                responsive={true}
                                current={currentPage ? currentPage + 1 : 1}
                                total={el?.data?.noOfPages * 12}
                                onChange={(e) =>
                                  handleChangePagination(
                                    e,
                                    el?.data?.chart_type
                                  )
                                }
                                showSizeChanger={false}
                                showTitle={false}
                              />
                            </div>
                          )}
                      </div>
                    ) : (
                      <>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ minHeight: "30rem" }}
                        >
                          <ErrorBoundary>
                            <NoGraphData
                              errorCode="No Data Found"
                              isCommandCenterScreen={
                                authParams?.screen_id &&
                                !isDeepDiveDashboardView
                              }
                            />
                          </ErrorBoundary>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            } else return null;
          })}

          {cardData?.PlatformID === 1 && (
            <Element
              id="element_retweet_map"
              name="element_retweet_map"
              onClick={() => accoArrowDw("maps")}
              // style={{
              //   backgroundColor:
              //     authParams?.theme_type === "1"
              //       ? "rgb(59 81 117 / 50%)"
              //       : "rgba(255, 255, 255, 0.3)",
              // }}
              className={`section-title trends p-10 ${
                authParams?.theme_type === "1" ? "" : "border"
              } border-color border-radius-4 d-flex align-items-center cursor-pointer mb-15 justify-content-between`}
            >
              <div className="text_heading-Slab font-size16 font-weight500">
                Maps
              </div>
              <img
                src={
                  authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                }
                alt="arrow"
                className="accordionArrow"
                style={{
                  transform: `rotate(${
                    accordion?.[2]?.value && accordion?.[2]?.id === 3
                      ? "0deg"
                      : "180deg"
                  })`,
                }}
              />
            </Element>
          )}

          {chartFinalData?.map((el, i) => {
            if (
              el?.chart_type === "retweet_map" ||
              el?.chart_type === "reply_map"
            ) {
              return (
                <div className="trends" id="element_retweet_map">
                  {i === 2 &&
                    (cardData?.card_type === "User Comment" ||
                      cardData?.card_type === "Brand Comment") && (
                      <div
                        className="portlet1 d-flex align-items-center mb-15 border-radius-4"
                        style={{ borderTop: "0.5rem solid #AC52FF" }}
                      >
                        <img src={ParentPost} alt="Parent Post icon" />
                        <div className="ml-15">
                          <div className="font-weight500 text_regular">
                            Parent post activity below
                          </div>
                          <div className="text_regular-gray">
                            All the activities of parent posts can be seen in
                            the detail view below
                          </div>
                        </div>
                      </div>
                    )}
                  <div
                    className={`portlet1 p-0 border border-color border-radius-4 ${
                      accordion?.[2]?.value && accordion?.[2]?.id === 3
                        ? ""
                        : "d-none"
                    } ${
                      i === chartFinalData?.length - 1 &&
                      (el?.data?.data ===
                        "No data available for selected post" ||
                        el?.widget_loader)
                        ? ""
                        : i === chartFinalData?.length - 1 &&
                          chartFinalData?.length === 5
                        ? " "
                        : " mb-15"
                    }`}
                    style={
                      i === chartFinalData?.length - 1 &&
                      (el?.data?.data ===
                        "No data available for selected post" ||
                        el?.widget_loader)
                        ? { marginBottom: "calc(100vh - " + 430 + "px )" }
                        : i === chartFinalData?.length - 1 &&
                          chartFinalData?.length === 5
                        ? { marginBottom: "calc(100vh - " + 515 + "px )" }
                        : {}
                    }
                  >
                    <div className="text_heading p-15 font-weight500 fontSize-16 border-bottom d-flex justify-content-between align-items-center">
                      {el?.chart_type === "kpi" ? (
                        "Detail View"
                      ) : el?.chart_type === "line" ? (
                        <div>
                          User Activities Trend{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "wordcloud" ? (
                        <div>
                          Post Wordcloud{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "retweet_map" ? (
                        <div>
                          Retweet Map{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "engaged_profiles_data" ? (
                        <div>
                          Engaged User Profiles{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : el?.chart_type === "reply_map" ? (
                        <div>
                          Reply Map{" "}
                          {(cardData?.card_type === "User Comment" ||
                            cardData?.card_type === "Brand Comment") && (
                            <span className="trands_post_pills">
                              Parent Post{" "}
                            </span>
                          )}
                        </div>
                      ) : (
                        el?.chart_type === "donut" && (
                          <div>
                            Sentiment Distribution{" "}
                            {(cardData?.card_type === "User Comment" ||
                              cardData?.card_type === "Brand Comment") && (
                              <span className="trands_post_pills">
                                Parent Post{" "}
                              </span>
                            )}
                          </div>
                        )
                      )}
                      {el?.chart_type === "line" && (
                        <div className="d-inline-flex align-items-center">
                          <div className="text_regular font-weight500 mr-2">
                            Duration
                          </div>
                          <Select
                            defaultValue={durationSelect}
                            onChange={handleDurationChange}
                            style={{ minWidth: "13rem" }}
                            className="border-color border-radius-4"
                            dropdownClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Option value="eight_hours">First 8 Hours</Option>
                            <Option value="sixteen_hours">
                              First 16 Hours
                            </Option>
                            <Option value="twenty_four_hours">
                              First 24 Hours
                            </Option>
                            <Option value="thirty_six_hours">
                              First 36 Hours
                            </Option>
                            <Option value="seven_days">First 7 Days</Option>
                            <Option value="thirty_days">First 30 Days</Option>
                            <Option value="ninety_days">First 90 Days</Option>
                            <Option value="six_months">First 6 Months</Option>
                            <Option value="one_year">First 1 Year</Option>
                            <Option value="lifetime">Lifetime</Option>
                          </Select>
                        </div>
                      )}
                    </div>
                    {el?.widget_loader ? (
                      <div className="loader" style={{ height: "30rem" }}>
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    ) : el?.data &&
                      el?.data?.data !==
                        "No data available for selected post" ? (
                      <div className="p-15 widget_trends" id={el?.widget_id}>
                        <ErrorBoundary>
                          <GraphList
                            widgetMakerGraphData={el?.data}
                            single={el?.data?.data}
                            style={chart__styles}
                            type={el?.chart_type}
                            trends={true}
                            xaxis={el?.data?.trace_name_xaxis}
                            yaxis={el?.data?.trace_name_yseries}
                          />
                        </ErrorBoundary>

                        {/* <EngagedCard data={el?.data?.data}/> */}
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ minHeight: "30rem" }}
                      >
                        <ErrorBoundary>
                          <NoGraphData
                            errorCode="No Data Found"
                            isCommandCenterScreen={
                              authParams?.screen_id && !isDeepDiveDashboardView
                            }
                          />
                        </ErrorBoundary>
                      </div>
                    )}
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
};

export default TrandsView;
